// extracted by mini-css-extract-plugin
export default {"bg":"CategoryModalStart_bg__2WBSS","modal":"CategoryModalStart_modal__dGP3-","active":"CategoryModalStart_active__00orX"};